module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/extensions-thumbnail/12-display-17e6ba779488306eafc21535407f4ec1.png";